const getDecimalLength = (value: number) => {
  return (value.toString().split(".")[1] ?? "").length
}

const multiply = (left: number, right: number) => {
  const x = Number(left.toString().replace(".", ""))
  const y = Number(right.toString().replace(".", ""))
  const decimalLength = getDecimalLength(left) + getDecimalLength(right)
  return (x * y) / 10 ** decimalLength
}

const add = (left: number, right: number) => {
  const n = 10 ** Math.max(getDecimalLength(left), getDecimalLength(right))
  return (multiply(left, n) + multiply(right, n)) / n
}

const sub = (left: number, right: number) => {
  const n = 10 ** Math.max(getDecimalLength(left), getDecimalLength(right))
  return (multiply(left, n) - multiply(right, n)) / n
}

const trunc = (value: number, place: number) => {
  const n = 10 ** place
  return Math.trunc(multiply(value, n)) / n
}

const DecimalMath = {
  add,
  sub,
  multiply,
  trunc,
} as const

export default DecimalMath
